import styled from 'styled-components';

import { sideNav, sideNavItem } from '../../styles/mixins';

const Container = styled.nav`
  ${sideNav}
`;

/* O espaço até o botão de ação vem do mixin `sideNav`, igual ao menu do cutter. */
const Menu = styled.ul``;

const MenuItem = styled.li`
  ${sideNavItem}
`;

export { Container, MenuItem, Menu };
